export var STORAGE;
(function (STORAGE) {
    STORAGE["USER_CONTEXT"] = "user_context";
    STORAGE["WELCOME_DIALOG_SHOWN"] = "ai-discoverability-welcome-dialog-shown";
    STORAGE["MOBILE_GATE_DISMISSED"] = "ai-discoverability-mobile-gate-dismissed";
    STORAGE["DISCOVER_MEMBERSHIPS"] = "discover_memberships";
})(STORAGE || (STORAGE = {}));
